import { ButtonInputWithPopover, SelectMultiple } from "@msys/ui";
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { InvoiceStatus } from "../../../../clients/graphqlTypes.js";
import {
  FilterChipGroup,
  FilterChipGroupProps,
} from "../../../commons/filters/FilterChip.js";
import { FilterProps } from "../../../commons/filters/index.js";
import { useInvoiceStatus } from "../useInvoiceStatus.js";

type Tab = "outgoing" | "incoming";

export function InvoiceStatusFilterButton(
  props: FilterProps<InvoiceStatus[]> & { tab: Tab }
) {
  const { t } = useTranslate(["Global"]);
  const { outgoingStatusOptions, incomingStatusOptions } = useInvoiceStatus();
  const statusOptions =
    props.tab === "outgoing" ? outgoingStatusOptions : incomingStatusOptions;

  return (
    <ButtonInputWithPopover
      label={t("Status", {
        ns: "Global",
      })}
      counter={
        props.value &&
        props.value.length > 0 &&
        props.value.length < statusOptions.length
          ? props.value.length
          : undefined
      }
      content={<InvoiceStatusFilterForm {...props} />}
      popoverWidth="md"
    />
  );
}

function InvoiceStatusFilterForm({
  value,
  setValue,
  tab,
}: FilterProps<InvoiceStatus[]> & { tab: Tab }) {
  const { outgoingStatusOptions, incomingStatusOptions } = useInvoiceStatus();
  const statusOptions =
    tab === "outgoing" ? outgoingStatusOptions : incomingStatusOptions;

  return (
    <Box p={1}>
      <FormControl component="fieldset" variant="standard">
        <FormGroup>
          {statusOptions.map((option, index) => (
            <FormControlLabel
              control={
                <Checkbox
                  size="medium"
                  checked={value.includes(option.value)}
                  onChange={(_event, checked) => {
                    if (checked) {
                      setValue(Array.from(new Set([...value, option.value])));
                    } else {
                      setValue(value.filter(v => v !== option.value));
                    }
                  }}
                />
              }
              label={<Typography variant="body1">{option.label}</Typography>}
              sx={{ ml: 0, mr: 0 }}
              key={`${option.value}-${index}`}
            />
          ))}
        </FormGroup>
      </FormControl>
    </Box>
  );
}

export function InvoiceStatusSelect({
  value,
  setValue,
  tab,
  ...props
}: FilterProps<InvoiceStatus[]> & { tab: Tab }) {
  const { t } = useTranslate("Global");
  const { outgoingStatusOptions, incomingStatusOptions } = useInvoiceStatus();

  return (
    <SelectMultiple
      label={t("Status", {
        ns: "Global",
      })}
      options={
        tab === "outgoing" ? outgoingStatusOptions : incomingStatusOptions
      }
      value={Array.isArray(value) ? value : [value]}
      onChange={setValue}
      {...props}
    />
  );
}
